export const getStepQuestion = (step) => {
    return step.c_question || step.c_description || step.c_text || '';
};
